/**
 * Enrollment statuses for a course.
 *
 * These come from get-available-classes.php in the legacy API.
 */

enum EnrollStatus {
	OPEN = "open",
	CLOSED = "closed",
	FULL = "full",
	WAITLIST = "waitlist",
}

export default EnrollStatus;
